// extracted by mini-css-extract-plugin
export default {"faq-accordion":"faq-accordion--VUomt","faqAccordion":"faq-accordion--VUomt","header":"header--vkllC","body":"body--+ns4O"};